/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ModalCancelButton } from "../../../components/modal_cancel_button";
import {
  CLOSE_ICON_COLOR,
  PartnershipDialogContent,
  PartnershipDialogHeader,
  PartnershipDialogTitle,
  PartnershipSubmitButton,
  StyledDialogActions,
  SubtitleText,
} from "../partnership_modal/styles";
import { SuccessDialog } from "./styles";

// Shown instead of the success snackbar when a partnership also created a restaurant, so
// the admin can go finish that restaurant's profile straight away.
export const PartnershipSuccessModal = ({ open, onClose, restaurant, restaurantGroup }) => {
  const navigate = useNavigate();

  // The update page reads these off the router state.
  const goToRestaurantProfile = () => {
    const restaurantId = restaurant?.id;
    const restaurantName = restaurant?.name;

    onClose();

    navigate(`/admin/restaurant/update/${restaurantId}`, {
      state: {
        restaurantId,
        restaurantName,
        restaurantGroupId: restaurantGroup?.id,
        restaurantGroupName: restaurantGroup?.name,
      },
    });
  };

  return (
    <SuccessDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      data-testid="partnership-success-modal"
      aria-labelledby="partnership-success-modal-title"
    >
      <PartnershipDialogHeader>
        <PartnershipDialogTitle id="partnership-success-modal-title" tabIndex={-1}>
          Partnership created successfully
        </PartnershipDialogTitle>
        <IconButton onClick={onClose} aria-label="Close partnership success modal">
          <CloseIcon sx={{ color: CLOSE_ICON_COLOR }} />
        </IconButton>
      </PartnershipDialogHeader>

      <PartnershipDialogContent dividers={false}>
        <SubtitleText data-testid="partnership-success-message">
          This partnership has added {restaurant?.name} as a new restaurant in{" "}
          {restaurantGroup?.name}. Do you want to complete the restaurant profile?
        </SubtitleText>
      </PartnershipDialogContent>

      <StyledDialogActions>
        <ModalCancelButton onClick={onClose} data-testid="partnership-success-dismiss-button">
          Not now
        </ModalCancelButton>
        <PartnershipSubmitButton
          onClick={goToRestaurantProfile}
          variant="contained"
          data-testid="partnership-success-go-button"
        >
          Go
        </PartnershipSubmitButton>
      </StyledDialogActions>
    </SuccessDialog>
  );
};

export default PartnershipSuccessModal;
